import { Component, OnDestroy, OnInit } from "@angular/core";

import { Observable } from "rxjs";
import { shareReplay } from "rxjs/operators";

import { DffHighchartsExtras, dffRenderHighcharts } from "@dffedb/highcharts";
import { SubSink } from "@dffedb/rxjs";

import { Forbrug } from "./model/forbrug.model";
import { SammenlignForbrugViewModel } from "./model/sammenlign-forbrug.viewmodel";
import { SammenlignForbrugService } from "./shared/sammenlign-forbrug.service";

@Component({
    selector: "sammenlign-forbrug",
    templateUrl: "./sammenlign-forbrug.component.html",
    styleUrls: ["./sammenlign-forbrug.component.scss"]
})
export class SammenlignForbrugComponent implements OnInit, OnDestroy {
    private readonly subs = new SubSink();
    public vm$: Observable<SammenlignForbrugViewModel>;
    public visSpinner = true;

    constructor(private readonly sammenlignForbrugService: SammenlignForbrugService) {}

    public async ngOnInit(): Promise<void> {
        this.vm$ = this.sammenlignForbrugService.hentData().pipe(shareReplay(1));
        this.subs.sink = this.vm$.subscribe((data) => {
            setTimeout(() => this.tegnForbrugsGraf(data.forbrug));
        });
    }

    public ngOnDestroy(): void {
        this.subs.unsubscribe();
    }

    private async tegnForbrugsGraf(forbrug: Forbrug): Promise<void> {
        if (forbrug.normtal > 0) {
            const options = this.genererGraf(forbrug);
            await dffRenderHighcharts(options, DffHighchartsExtras.bullet);
        }
        this.visSpinner = false;
    }

    private genererGraf(forbrug: Forbrug): any {
        const realiseret = forbrug.realiseret;
        const dkRealiseret = this.sammenlignForbrugService.formatterNummer(realiseret);
        const normtal = forbrug.normtal;
        const roedMaksimum = normtal * 2; // Der ganges med 2 for at sikre at den røde farve dækker nok
        const groenMaksimum = normtal - normtal / 4;
        const gulMaksimum = normtal + normtal / 4;

        const options: any = {
            chart: {
                renderTo: "chart",
                marginTop: 40,
                marginLeft: 0,
                inverted: true,
                type: "bullet"
            },
            title: {
                useHTML: true,
                align: "left",
                text: `<span><small>Dit forbrug er ${dkRealiseret} ${forbrug.enhed}/m<sup>2</sup></small></span>`
            },
            legend: {
                enabled: false
            },
            xAxis: {
                categories: [""]
            },
            yAxis: {
                gridLineWidth: 0,
                plotBands: [
                    {
                        from: 0,
                        to: groenMaksimum,
                        color: "#2ECC40"
                    },
                    {
                        from: groenMaksimum,
                        to: gulMaksimum,
                        color: "#FFDC00"
                    },
                    {
                        from: gulMaksimum,
                        to: roedMaksimum * 2,
                        color: "#FF4136"
                    }
                ],
                max: roedMaksimum,
                title: ""
            },
            series: [
                {
                    data: [
                        {
                            y: realiseret,
                            target: normtal
                        }
                    ]
                }
            ],
            plotOptions: {
                series: {
                    pointPadding: 0.3,
                    borderWidth: 0,
                    color: "#262626",
                    targetOptions: {
                        width: "200%",
                        color: "#FF851B"
                    }
                }
            },
            credits: {
                enabled: false
            },
            exporting: {
                enabled: false
            },
            tooltip: {
                enabled: false
            }
        };

        return options;
    }
}
